import { useState } from "react"
import DynamicCardRow from "../../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow"
import SellerRetailerListed from "../../../../components/AdminPortalComponents/ProductManagement/ProductOverview/SellerRetailerListed/SellerRetailerListed"
import Wholesale from "../../../../components/AdminPortalComponents/ProductManagement/ProductOverview/Wholesale/Wholesale"
import DynamicSquaredFilterBar from "../../../../components/common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar"

const ProductsOverview = () => {
  const tabs = [
    { key: 'sellerRetailerListed', label: 'Seller/Retailer listed' },
    { key: 'wholesale', label: 'Wholesale' },
  ]
  const [activeTab, setActiveTab] = useState(tabs[0].key)

  const cardsData = [
    { title: "TOTAL PRODUCTS", value: 0 },
    { title: "FBM PRODUCTS", value: 0 },
    { title: "SELLER/WHOLESALE PRODUCTS", value: 0 },
    { title: "LOW STOCK ALERTS", value: 0 },
  ]

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f2f2f2", padding: "1rem" }}>
      <div className="shadow bg-white p-3">
        <div className="mb-3 fw-semibold fs-4">Products</div>
        <DynamicCardRow cards={cardsData} />
      </div>

      <div className="p-3 bg-white mt-3 shadow d-flex flex-column gap-2">
        <DynamicSquaredFilterBar tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
        {activeTab === "sellerRetailerListed" && <SellerRetailerListed />}
        {activeTab === "wholesale" && <Wholesale />}
      </div>
    </div>
  )
}

export default ProductsOverview
